import React, { Component } from 'react';
import config from '../lib/config';
import moment from 'moment';
import {Tooltip, Switch} from 'antd';
import {Link} from 'react-router-dom';

export default class ContactWidget extends Component{
  constructor(props){
    super(props);

    this.state = {
        
    }
  }
  componentWillMount(){

  }
  componentWillReceiveProps(nextProps){

  }
  componentDidUpdate(prevProps, prevState){
    
  }
  
  render(){
    if(!this.props.Contact) return null
      // console.log(this.props);
    let time_contact = moment(this.props.Contact.last_time);
    let last_time_contact = '';
    
    if(moment(this.props.Contact.last_time).startOf('day').unix() == moment(new Date()).startOf('day').unix()){
      last_time_contact = `${time_contact.fromNow()}`;
    } else{
      if(moment(this.props.Contact.last_time).startOf('year').unix() == moment(new Date()).startOf('year').unix()){
        last_time_contact = `${time_contact.fromNow('Do MMMM')}`;
      } else{
        last_time_contact = `${time_contact.format('MMMM YYYY')}`;
      }
    }
    let channel = this.props.Contact.channel;
    let avatar = this.props.Contact.avatar || this.props.Contact.picture;
    let isGroupChat = this.props.Contact.type === "group";
    let memberAvatars = this.props.Contact.member_avatars || [];
    
    let source_icon = <span>KXD</span>;
    if(channel && config.type_account_social[channel.acc_type]){
      const acc_conf = config.type_account_social[channel.acc_type];
      if (acc_conf['icon']) {
        const icon_src = typeof acc_conf['icon'] === 'object' ? acc_conf['icon'].default || acc_conf['icon'] : acc_conf['icon'];
        source_icon = <img src={icon_src} />;
      } else {
        source_icon = <span>{acc_conf['name']}</span>;
      }
    }

    if(this.props.Contact.type == "callcenter"){
     source_icon = <span>call</span>
    } else if(this.props.Contact.type == "www" || this.props.Contact.type == "webchat"){
      if (!channel || !config.type_account_social[channel.acc_type]) {
         source_icon = <img src="../img/menu/new_icons/icon-webchat.png" alt="webchat" />
      }
    } else if(this.props.Contact.type == "telegram"){
      if (!channel || !config.type_account_social[channel.acc_type]) {
         source_icon = <span><i className="fa fa-telegram" style={{ padding: "0 2px"}}></i></span>
      }
    }

    // Render avatar - composite cho nhóm, single cho cá nhân
    const renderAvatar = () => {
      if (isGroupChat && memberAvatars.length > 0) {
        const totalMember = this.props.Contact.total_member || memberAvatars.length;
        const avatarCount = Math.min(memberAvatars.length, 3);
        const showMemberBadge = totalMember > 3;
        const avatarSize = showMemberBadge ? 22 : (avatarCount === 3 ? 24 : 28);
        
        // Layout cho 3 avatar: tam giác (1 trên, 2 dưới)
        if (avatarCount === 3 && !showMemberBadge) {
          return (
            <div className="group-avatar-composite" style={{
              position: 'relative',
              width: '48px',
              height: '48px'
            }}>
              {/* Avatar trên cùng - giữa */}
              <img 
                src={memberAvatars[0] || '/user.jpg'}
                alt=""
                style={{
                  position: 'absolute',
                  width: `${avatarSize}px`,
                  height: `${avatarSize}px`,
                  borderRadius: '50%',
                  border: '2px solid #fff',
                  objectFit: 'cover',
                  top: '0',
                  left: '50%',
                  transform: 'translateX(-50%)',
                  zIndex: 3,
                  boxShadow: '0 1px 2px rgba(0,0,0,0.1)'
                }}
                onError={(e) => { e.target.src = '/user.jpg' }}
              />
              {/* Avatar dưới trái */}
              <img 
                src={memberAvatars[1] || '/user.jpg'}
                alt=""
                style={{
                  position: 'absolute',
                  width: `${avatarSize}px`,
                  height: `${avatarSize}px`,
                  borderRadius: '50%',
                  border: '2px solid #fff',
                  objectFit: 'cover',
                  bottom: '0',
                  left: '2px',
                  zIndex: 2,
                  boxShadow: '0 1px 2px rgba(0,0,0,0.1)'
                }}
                onError={(e) => { e.target.src = '/user.jpg' }}
              />
              {/* Avatar dưới phải */}
              <img 
                src={memberAvatars[2] || '/user.jpg'}
                alt=""
                style={{
                  position: 'absolute',
                  width: `${avatarSize}px`,
                  height: `${avatarSize}px`,
                  borderRadius: '50%',
                  border: '2px solid #fff',
                  objectFit: 'cover',
                  bottom: '0',
                  right: '2px',
                  zIndex: 1,
                  boxShadow: '0 1px 2px rgba(0,0,0,0.1)'
                }}
                onError={(e) => { e.target.src = '/user.jpg' }}
              />
            </div>
          );
        }
        
        // Layout cho 4+ avatar: vuông 2x2 (3 avatar + badge số)
        if (showMemberBadge) {
          return (
            <div className="group-avatar-composite" style={{
              position: 'relative',
              width: '48px',
              height: '48px',
              display: 'grid',
              gridTemplateColumns: 'repeat(2, 1fr)',
              gridTemplateRows: 'repeat(2, 1fr)',
              gap: '2px'
            }}>
              {memberAvatars.slice(0, 3).map((avt, idx) => (
                <img 
                  key={idx}
                  src={avt || '/user.jpg'}
                  alt=""
                  style={{
                    width: `${avatarSize}px`,
                    height: `${avatarSize}px`,
                    borderRadius: '50%',
                    border: '1px solid #fff',
                    objectFit: 'cover',
                    boxShadow: '0 1px 2px rgba(0,0,0,0.1)'
                  }}
                  onError={(e) => { e.target.src = '/user.jpg' }}
                />
              ))}
              {/* Badge số thành viên */}
              <div style={{
                width: `${avatarSize}px`,
                height: `${avatarSize}px`,
                borderRadius: '50%',
                border: '1px solid #fff',
                background: '#e0e0e0',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '10px',
                fontWeight: 600,
                color: '#555',
                boxShadow: '0 1px 2px rgba(0,0,0,0.1)'
              }}>
                {totalMember}
              </div>
            </div>
          );
        }
        
        // Layout cho 1-2 avatar
        return (
          <div className="group-avatar-composite" style={{
            position: 'relative',
            width: '48px',
            height: '48px'
          }}>
            {memberAvatars.slice(0, 2).map((avt, idx) => (
              <img 
                key={idx}
                src={avt || '/user.jpg'}
                alt=""
                style={{
                  position: 'absolute',
                  width: avatarCount === 1 ? '48px' : '28px',
                  height: avatarCount === 1 ? '48px' : '28px',
                  borderRadius: '50%',
                  border: '2px solid #fff',
                  objectFit: 'cover',
                  top: idx === 0 ? '0' : '18px',
                  left: idx === 0 ? '0' : '18px',
                  zIndex: 2 - idx,
                  boxShadow: '0 1px 2px rgba(0,0,0,0.1)'
                }}
                onError={(e) => { e.target.src = '/user.jpg' }}
              />
            ))}
          </div>
        );
      }
      // Single avatar
      return (
        <img className="avatar" alt="avatar" 
          src={avatar} 
          onLoad={(e)=>{
            e.target.className = "avatar-ready avatar";
          }}
          onError={(e) => {
            e.target.src = "/user.jpg"
          }}
        />
      );
    };

    return(
        <li className={this.props.contactInfoSelected && this.props.contactInfoSelected._id == this.props.Contact._id ? 'selected' : ''} >
            <Link to={`/chat/${this.props.Contact.contact_id}`}>
              <div className="avatar-box">
                  {renderAvatar()}
                  <Tooltip placement="bottom" title={channel ? channel.username : ""} 
                    mouseEnterDelay={this.props.mouseEnterDelayTooltip} 
                    mouseLeaveDelay={this.props.mouseLeaveDelayTooltip}
                  >
                    <div className="info-source">
                      <div className="source-icon">
                        {source_icon}
                      </div>
                    </div>
                  </Tooltip>
              </div>
              <div className={!this.props.Contact.read_state == 1 ? "read-contact text-box" : "text-box"}>
                  <div className="d-flex justify-content-between align-items-baseline" style={{ overflow: 'hidden' }}>
                      <div className="contact-name-row" style={{ display: 'flex', alignItems: 'center', overflow: 'hidden', marginRight: '8px' }}>
                        {isGroupChat && <i className="fa fa-users" style={{ color: '#888', fontSize: '14px', marginRight: '6px', flexShrink: 0 }}></i>}
                        <span className="contact-title">{this.props.Contact.thread_title || 'Không xác định'}</span>
                        {this.props.Contact.channel && <span className="channel-alias">{this.props.Contact.channel.alias}</span>}
                      </div>
                      <div className="note-time">{last_time_contact}</div>
                  </div>
                  <div className="sidepanel-item-note">
                      <div className="note-content">
                        {(() => {
                          let snippet = this.props.Contact.snippet || '';
                          
                          // Check các loại media
                          if (snippet.includes('photo-stal-7.zdn.vn') || snippet.match(/\.(jpeg|jpg|gif|png)$/) != null) {
                            snippet = "[Hình ảnh]";
                          } else if (snippet.match(/\.(mp4|mov)$/) != null) {
                            snippet = "[Video]";
                          } else if (snippet.match(/\.(mp3|wav)$/) != null) {
                            snippet = "[Âm thanh]";
                          } else if (snippet.includes('zalo-api.zadn.vn/api/emoticon')) {
                            snippet = "[Nhãn dán]";
                          }
                          
                          // Với hội thoại nhóm: format "TênBot: Abc" thành <b>TênBot</b>: Abc
                          if (isGroupChat && snippet.includes(': ')) {
                            const colonIndex = snippet.indexOf(': ');
                            const senderName = snippet.substring(0, colonIndex);
                            const msgContent = snippet.substring(colonIndex + 2);
                            return (
                              <>
                                <span style={{ fontWeight: 600 }}>{senderName}</span>
                                <span>: {msgContent}</span>
                              </>
                            );
                          }
                          
                          return snippet;
                        })()}
                      </div>
                      {
                        this.props.Contact.read_state == 1 ?
                        <span className="unread">1</span>
                        : null
                      }
                  </div>
                  {
                    this.props.Contact.sale && this.props.Contact.sale.status == 4 ?
                    <div className="contact-confirm"><span className="icon" style={{background: '#9c27b0'}}>AI</span></div>
                    : this.props.Contact.sale && this.props.Contact.sale.status == 0 ? 
                    <div className="contact-confirm"><span className="icon">new</span></div> : this.props.Contact.tags && this.props.Contact.tags.length > 0 ?
                    <div className="list-tags">
                      {this.props.Contact.tags.map((item) => {
                        return <Tooltip key={item.tag_id} placement="top" title={item.tag_name} 
                        mouseEnterDelay={this.props.mouseEnterDelayTooltip} 
                        mouseLeaveDelay={this.props.mouseLeaveDelayTooltip}
                      >
                        <span
                          className="item-tag-2" 
                          style={{background: item.tag_color}}
                        ></span>
                      </Tooltip>
                      })}
                    </div> : <div className="list-tags" style={{marginBottom: "5px"}}></div>
                  }
              </div>
            </Link>
        </li>
    )
  }
}
